import { render, staticRenderFns } from "./contract-balance.vue?vue&type=template&id=0810b1fb&scoped=true&"
import script from "./contract-balance.vue?vue&type=script&lang=js&"
export * from "./contract-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810b1fb",
  null
  
)

export default component.exports